import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-9xl font-bold text-indigo-600">404</h1>
            <h2 className="text-3xl font-semibold mt-4 text-gray-800">Страница не найдена</h2>
            <p className="text-gray-500 mt-2 max-w-md">
                К сожалению, запрашиваемая вами страница не существует или была перемещена.
            </p>
            <button
                onClick={() => navigate('/')}
                className="mt-8 px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors shadow-lg"
            >
                Вернуться на главную
            </button>
        </div>
    );
};

export default NotFoundPage;